import React from 'react';
import { Card, Title, Button } from '@tremor/react';
import SupplierForm from '../../pages/Admin/Suppliers/SupplierForm';
import type { Supplier } from '../../types/supplier';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  initialData?: Supplier;
  onSubmit: (data: Supplier) => Promise<void>;
  isSubmitting: boolean;
  error: string | null;
  title: string;
  submitLabel: string;
}

export default function SupplierFormModal({
  isOpen,
  onClose,
  initialData,
  onSubmit,
  isSubmitting,
  error,
  title,
  submitLabel
}: Props) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <Card className="w-full max-w-2xl max-h-[90vh] overflow-y-auto bg-white">
        <div className="flex justify-between items-center mb-6">
          <Title>{title}</Title>
          <Button variant="light" onClick={onClose}>Close</Button>
        </div>

        <SupplierForm
          initialData={initialData}
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          error={error}
          onCancel={onClose}
          submitLabel={submitLabel}
        />
      </Card>
    </div>
  );
}
